import { ComponentPropsOptions, computed, h } from '@vue/composition-api';
import { NodeProps, ValidConnectionFunc } from '../../types';
import { Position } from '../../types';
import { defineComponent } from '@vue/composition-api';
import { Fragment } from 'vue-frag';
import { PropType } from 'vue';
import { IWorkflowState } from '@/models';
import { HexToRGB } from '@/utils/colorUtils';

const NodeLabel = defineComponent<Partial<NodeProps<IWorkflowState>>>({
  name: 'NodeLabel',

  components: {
    Fragment
  },

  props: {
    sourcePosition: {
      type: String,
      default: () => Position.Bottom
    },
    targetPosition: {
      type: String,
      default: () => Position.Top
    },
    selected: {
      type: Boolean
    },
    connectable: {
      type: Boolean,
      default: true
    },
    isValidTargetPos: {
      type: Function as PropType<ValidConnectionFunc>
    },
    isValidSourcePos: {
      type: Function as PropType<ValidConnectionFunc>
    },
    data: {
      type: Object as PropType<IWorkflowState>,
      default: () => ({} as IWorkflowState)
    }
  } as ComponentPropsOptions<Partial<NodeProps<IWorkflowState>>>,

  setup(props, _context) {
    const label = computed(() => props.data!.name || props.label);

    const color = computed(() => props.data!.config.color);
    const nodeColorRGB = computed(() => HexToRGB(color.value ?? '#FFFFFF'));

    return () =>
      h(
        'VSheet',
        {
          class: 'd-flex align-center justify-center rounded pa-4',
          style: {
            transition: 'border 120ms cubic-bezier(0.4, 0, 0.2, 1)',
            border: `${props.selected ? 1.5 : 1}px solid rgba(${
              nodeColorRGB.value.r
            }, ${nodeColorRGB.value.g}, ${nodeColorRGB.value.b}, ${
              props.selected ? 0.84 : 0.12
            })`
          },
          props: {
            outlined: true,
            height: '100%',
            width: '100%'
          }
        },
        [
          h(
            'VIcon',
            {
              class: 'position-absolute',
              style: {
                left: '6px',
                top: '6px',
                position: 'absolute !important'
              },
              props: {
                size: 14,
                color: color.value
              }
            },
            ['mdi-sitemap']
          ),
          h(
            'VIcon',
            {
              class: 'position-absolute',
              style: {
                right: '6px',
                top: '6px',
                position: 'absolute !important'
              },
              props: {
                size: 14,
                color: color.value
              }
            },
            [props.data!.is_locked ? 'mdi-lock' : 'mdi-lock-open-variant']
          ),
          h(
            'span',
            {
              class: 'font-weight-medium'
            },
            [label.value as string]
          ),
          // props.data?.default.toString()
          h(
            'span',
            {
              class: 'workflow__node-label-underlay',
              style: {
                background: `rgb(${nodeColorRGB.value.r}, ${nodeColorRGB.value.g}, ${nodeColorRGB.value.b})`
              }
            },
            []
          )
        ]
      );
  }
});

export default NodeLabel;
